import {
  Building2,
  Globe,
  Headphones,
  Network,
  Phone,
  Router,
  Server,
  Shield,
  Wifi,
  Zap,
} from "lucide-react";

const ICON_MAP = { Zap, Building2, Network, Server, Wifi, Headphones, Globe, Shield, Router, Phone };

export const ServiceIcon = ({ name, className }) => {
  const Icon = ICON_MAP[name] || Globe;
  return <Icon className={className} />;
};

export const ICON_NAMES = Object.keys(ICON_MAP);
